import type { BookingStatus, ContactStatus, Locale } from "@dteba/shared";

/**
 * One place for every cache key, so a locale switch or a CMS publish can
 * invalidate exactly the right slice instead of nuking the whole cache.
 */
export const queryKeys = {
  settings: (locale: Locale) => ["settings", locale] as const,
  home: (locale: Locale) => ["pages", "home", locale] as const,
  villa: (locale: Locale) => ["pages", "villa", locale] as const,
  story: (locale: Locale) => ["pages", "story", locale] as const,
  experiences: (locale: Locale) => ["pages", "experiences", locale] as const,
  gallery: (locale: Locale) => ["pages", "gallery", locale] as const,
  faqs: (locale: Locale) => ["faqs", locale] as const,
  legal: (slug: string, locale: Locale) => ["legal", slug, locale] as const,
  availability: () => ["bookings", "availability"] as const,
  bookingReceipt: (reference: string) => ["bookings", "receipt", reference] as const,
  admin: {
    pages: () => ["admin", "pages"] as const,
    media: () => ["admin", "media"] as const,
    mediaUsage: () => ["admin", "media", "usage"] as const,
    bookings: (status?: BookingStatus) => ["admin", "bookings", status ?? "all"] as const,
    bookingStats: () => ["admin", "bookings", "stats"] as const,
    contactMessages: (status?: ContactStatus) => ["admin", "contact-messages", status ?? "all"] as const,
    settings: () => ["admin", "settings"] as const,
  },
} as const;
